import * as React from "react";

function SvgArrowCircleIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 194 194" {...props}><path d="M96.9 2c-52.4 0-95 42.6-95 95s42.6 95 95 95 95-42.6 95-95-42.6-95-95-95zM78.2 150.4l-10.6-10.6L110.3 97 67.6 54.2l10.6-10.6L131.5 97l-53.3 53.4z" /></svg>;
}

export default SvgArrowCircleIcon;